var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 2.4C9.36 2.4 10.4 3.44 10.4 4.8C10.4 6.16 9.36 7.2 8 7.2C6.64 7.2 5.6 6.16 5.6 4.8C5.6 3.44 6.64 2.4 8 2.4ZM8 13.76C6 13.76 4.24 12.72 3.2 11.2C3.2 9.6 6.4 8.72 8 8.72C9.6 8.72 12.8 9.6 12.8 11.2C11.76 12.72 10 13.76 8 13.76Z",
    fill: "#71828C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.0bf438a2febb6f4a54440c6322cfe1bb.svg";
export { ForwardRef as ReactComponent };